import createSdk from '@passkeys/headless';

import adapters from '@/background/adapters/adapters.js';
import config from '@/background/config.js';
import airdrop from '@/background/features/airdrop/index.js';
import analytics from '@/background/features/analytics/index.js';
import assetManagement from '@/background/features/asset-management';
import blinks from '@/background/features/blinks/index.js';
import customTokens from '@/background/features/custom-tokens/index.js';
import exchangeClient from '@/background/features/exchange-client/index.js';
import fiatRamp from '@/background/features/fiat-ramp/index.js';
import pairing from '@/background/features/pairing';
import passkey from '@/background/features/passkey/index.js';
import playgroundSbt from '@/background/features/playground-sbt/index.js';
import privateKeys from '@/background/features/private-keys/index.js';
import pwa from '@/background/features/pwa';
import testnets from '@/background/features/testnets/index.js';
import web3 from '@/background/features/web3/index.js';
import eventsReduxMap from '@/constants/events-redux-map.js';
import { referrerURL } from '@/utils/referrer';
import { dispatchReduxEvent, store } from './flux/index.js';

const sdk = createSdk({ config, adapters, eventsReduxMap })
  .use(airdrop())
  .use(analytics())
  .use(assetManagement())
  .use(blinks())
  .use(customTokens())
  .use(exchangeClient())
  .use(fiatRamp(config.fiatRamp))
  .use(pairing())
  .use(passkey())
  .use(playgroundSbt())
  .use(privateKeys())
  .use(pwa())
  .use(testnets())
  .use(web3());

const exodus = sdk.resolve();

const handleExodusEvent = ({ type: event, payload }) => {
  const type = eventsReduxMap[event];

  if (type) {
    store.dispatch({ type, payload });
  }

  if (event === 'lock' && !__STANDALONE_MODE__) {
    window.parent.postMessage('wallet:locked', referrerURL);
  }

  if (event === 'unlock' && !__STANDALONE_MODE__) {
    window.parent.postMessage('wallet:unlocked', referrerURL);
  }

  try {
    dispatchReduxEvent(event, payload);
  } catch (error) {
    console.error('redux-dependency-injection: error handling event', error);
  }
};
exodus.subscribe(handleExodusEvent);

exodus.wallet.start();

exodus.subscribe(async ({ type }) => {
  if (type !== 'restart') {
    return;
  }

  await exodus.wallet.lock();
});

if (import.meta.env.DEV) {
  (window as any).passkeys = exodus;
  (window as any).store = store;
}

// Handle requests coming from web3 providers.
window.addEventListener('message', (event) => {
  // Web3 requests are restricted to partner dApps only.
  if (!exodus.web3.verifyOrigin(event.origin)) {
    return;
  }

  if (event.data?.type !== 'provider:request') {
    return;
  }

  exodus.web3.handleProviderRequest(event.data.input);
});

export default exodus;
